import { Box, Container } from "@mui/material";
import CreateTicketPage from "./CreateTicket";

export default function CreateManagementTicketPage() {
  // One stable tree for every width: the wrapper no longer swaps between
  // Container and Box per breakpoint, so rotating/resizing never remounts
  // the form and typed content is kept.
  return (
    <Box height={1} overflow="auto">
      <Container disableGutters sx={{ p: 1 }}>
        <CreateTicketPage />
      </Container>
    </Box>
  );
}